import './new.notes.header.scss';

import { Typography } from '@mui/material';

export interface INotesHeaderProps {
  title: string;
}

export const NotesHeader = ({ title }: INotesHeaderProps) => {
  return (
    <>
      <Typography className="broker-note-header" variant="body1">
        {title}
      </Typography>
    </>
  );
};
